// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var convertToNumber = function (val) {
    if (val === null || val === undefined) {
        return null;
    }
    if (typeof val === "number") {
        return val;
    }
    if (typeof val === "boolean") {
        return val ? 1 : 0;
    }
    if (typeof val === "string") {
        var num = parseFloat(val);
        return isNaN(num) ? null : num;
    }
    // For any other types return null
    return null;
};
export var getPreferenceKey = function (key, subkey) {
    return "".concat(key.replaceAll("/", "_").replaceAll("-", "_"), "_").concat(subkey);
};
// function to convert null values to void string for comparison
var customSortComparator = function (a, b, field, order) {
    var aValue = a[field] != null ? a[field] : "";
    var bValue = b[field] != null ? b[field] : "";
    if (typeof aValue === "string" && typeof bValue === "string") {
        return order === "ASC" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }
    if (aValue < bValue)
        return order === "ASC" ? -1 : 1;
    if (aValue > bValue)
        return order === "ASC" ? 1 : -1;
    return 0;
};
// A function that sorts an array of records using our custom comparator.
export var customSortData = function (data, sort) {
    return __spreadArray([], data, true).sort(function (a, b) { return customSortComparator(a, b, sort.field, sort.order); });
};
